import { atom, useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export const storageKey = 'forceStoragePassthrough';

const strAtomWithStorage = atomWithStorage(storageKey, '');

const boolAtomWithStorage = atom(
  get => !!get(strAtomWithStorage),
  (_, set, val: boolean) => {
    set(strAtomWithStorage, val ? 'true' : '');
  },
);

const useForceStoragePassthrough = () => useAtom(boolAtomWithStorage);

export default useForceStoragePassthrough;
